import apiService from './api.service';
import type { NavModuleKey } from '@/config/navigationModules';

export type NavigationModulesResponse = {
  modules: Partial<Record<NavModuleKey, { operational: boolean }>>;
};

export async function getMyNavigationModules(): Promise<NavigationModulesResponse> {
  const response = await apiService.get<NavigationModulesResponse>('/auth/me/navigation-modules');
  if (response.data?.modules) {
    return response.data;
  }
  return { modules: {} };
}
